import styled from 'styled-components';

import { FlexColumnCenterVertical, FlexRowCenterVertical } from '@main/core-ui';
import { Button } from '@main/pc-core-components';
import { sp } from '@main/theme';

/*
 * Card-like container wrapper for displaying privacy related settings
 */
export const StyledCardWrapper = styled(FlexColumnCenterVertical)<{
  /** flag for whether card is disabled */
  disabled: boolean;
}>`
  padding: ${sp(1.5)} ${sp(1.5)};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.gray3};
  background-color: ${({ theme }) => theme.colors.white};
  gap: ${sp(2)};
  opacity: ${({ disabled }) => (disabled ? '60%' : '100%')};
`;

/**
 *  Card title container
 */
export const StyledCardTitleContainer = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  gap: ${sp(1.5)};
  padding: 0 ${sp(1)};
`;

/*
 * Card title wrapper
 *
 * TODO: https://transcend.height.app/T-39201 - Remove h2 componentStyle when fixed
 */
export const StyledCardTitleWrapper = styled.h2`
  ${({ theme }) => theme.componentStyles.h2};
  text-align: left;
  flex-grow: 1;
`;

/*
 * Wrapper for contents of the card
 */
export const StyledCardInfoWrapper = styled(FlexColumnCenterVertical)`
  gap: inherit;
  padding: 0 ${sp(1)} ${sp(0.5)} ${sp(1)};
`;

/*
 * Wrapper for primary button
 */
export const StyledPrimaryButton = styled(Button)`
  padding: ${sp(1)} ${sp(1.5)};
`;

/*
 * Wrapper for secondary button
 */
export const StyledSecondaryButton = styled(Button)`
  padding: ${sp(1)} ${sp(1.5)};
  color: ${({ theme }) => theme.colors.primary};
`;
